/**
 * 普通键值对对象
 * @param data 对象
 * @returns formData
 */
export const objectToFormData = (data: Record<string, any>) => {
  const formData = new FormData();
  Object.keys(data).forEach(key => {
    formData.append(key, data[key]);
  });
  return formData;
};
